module.exports = __webpack_public_path__ + "img/ic-favorite-fill.bb58cc6c.svg";